<template>
  <section class="section ecosystem-rings" id="ecosystems">
    <div class="container">
      <SectionHead eyebrow="FOUR ECOSYSTEMS">
        四大生态，重塑你的<span class="gradient-text">商业逻辑</span>
      </SectionHead>
      <p class="section-copy eco-copy">
        从项目发掘到交付回款的全生命周期解决方案。每个生态都为你敞开注册入口。
      </p>
      <div class="big-eco-grid">
        <article
          v-for="eco in ecosystems"
          :key="eco.slug"
          class="big-eco-card reveal"
          :style="{ backgroundImage: 'url(' + eco.image + ')' }"
          @click="$router.push('/ecosystem/' + eco.slug)"
        >
          <div class="big-eco-meta">
            <span class="big-eco-no">{{ eco.index }}</span>
          </div>
          <div class="big-eco-foot">
            <h3>{{ eco.name }}</h3>
            <p>{{ eco.slogan }}</p>
          </div>
          <div class="big-eco-arrow">→</div>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import SectionHead from '@/components/display/SectionHead.vue';

export default {
  name: 'HomeEcosystems',
  components: { SectionHead },
  computed: {
    ...mapState('ecosystem', ['ecosystems'])
  }
};
</script>

<style lang="less" scoped>
.ecosystem-rings {
  position: relative;
  background: radial-gradient(ellipse at 50% 40%, rgba(131, 230, 255, 0.04), transparent 60%);
  overflow: hidden;
}

.eco-copy {
  text-align: center;
  max-width: 880px;
  margin: -30px auto 40px;
}

.big-eco-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  max-width: 1240px;
  margin: 50px auto 60px;
}

.big-eco-card {
  position: relative;
  height: 320px;
  border-radius: 20px;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  cursor: pointer;
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.4s;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.32);

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.15) 0%, transparent 30%, transparent 50%, rgba(0, 0, 0, 0.75) 100%);
    z-index: 1;
    transition: background 0.35s;
  }

  &:hover {
    transform: translateY(-6px) !important;
    box-shadow: 0 24px 56px rgba(0, 0, 0, 0.5);

    &::after {
      background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 0%, transparent 30%, transparent 40%, rgba(0, 0, 0, 0.85) 100%);
    }
    .big-eco-arrow {
      background: rgba(131, 230, 255, 0.25);
      border-color: #83e6ff;
      transform: scale(1.1) translateX(2px);
      box-shadow: 0 0 18px rgba(131, 230, 255, 0.4);
    }
  }
}

.big-eco-meta {
  position: absolute;
  top: 26px;
  left: 30px;
  z-index: 2;
}

.big-eco-no {
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 0.18em;
  padding-left: 14px;
  position: relative;
  opacity: 0.9;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    width: 10px;
    height: 1px;
    background: #fff;
    transform: translateY(-50%);
    opacity: 0.8;
  }
}

.big-eco-foot {
  position: absolute;
  bottom: 30px;
  left: 30px;
  right: 90px;
  z-index: 2;

  h3 {
    font-size: 24px;
    font-weight: 700;
    color: #fff;
    margin: 0 0 6px;
    letter-spacing: 0.02em;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
  }

  p {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.78);
    margin: 0;
    letter-spacing: 0.02em;
    text-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  }
}

.big-eco-arrow {
  position: absolute;
  bottom: 30px;
  right: 30px;
  z-index: 2;
  width: 46px;
  height: 46px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(8px);
  transition: all 0.3s;
}

.big-eco-card.reveal.show:nth-child(2) { transition-delay: 0.12s; }
.big-eco-card.reveal.show:nth-child(3) { transition-delay: 0.24s; }
.big-eco-card.reveal.show:nth-child(4) { transition-delay: 0.36s; }

@media (max-width: 820px) {
  .big-eco-grid {
    grid-template-columns: 1fr;
    gap: 18px;
    margin: 36px auto 40px;
  }
  .big-eco-card {
    height: 240px;
  }
}
</style>
